// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"DO-z","categoryName":"EO-z","categoryNameSearchHeader":"FO-z","categoryContent":"GO-z","bottomAligned":"HO-z","image":"IO-z","imageNoBackground":"JO-z"};